/**
 * "Show more" for the desktop product media grid
 * (snippets/product-media-gallery-content.liquid). The grid renders the first
 * N images and hides the rest with `.pacc-media--hidden` (plus an inline
 * `display: none`, so hiding doesn't depend on the stylesheet); each click reveals
 * the next batch. The button removes itself once everything is shown.
 */
class PaccMediaShowMore extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.#onClick);
  }

  #onClick = () => {
    const grid = this.previousElementSibling;
    if (!grid) return;

    const step = Number(this.dataset.step) || 8;
    const hidden = [...grid.querySelectorAll(':scope > .pacc-media--hidden')];
    const reveal = hidden.slice(0, step);

    for (const item of reveal) {
      item.classList.remove('pacc-media--hidden');
      /** @type {HTMLElement} */ (item).style.removeProperty('display');
    }

    if (hidden.length <= step) {
      // The button is about to disappear; keep keyboard focus in the gallery
      this.hidden = true;
      /** @type {HTMLElement | null} */ (reveal[0]?.querySelector('button, a') ?? null)?.focus({ preventScroll: true });
    }
  };
}

if (!customElements.get('pacc-media-show-more')) {
  customElements.define('pacc-media-show-more', PaccMediaShowMore);
}
